import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import {
  Button,
  Form,
  Modal,
  Select,
  Space,
  Table,
  Tabs,
  Typography,
} from "antd";
import { getDirectusClient } from "../../lib/directus";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import Caja from "./components/Caja";
import Grupo from "./components/Grupo";
import Serial from "./components/Serial";

import { createItem, readItems, readUsers, updateItem } from "@directus/sdk";
import { useSelector } from "react-redux";
const { Title } = Typography;
const { Option } = Select;
const arraytotalproductos = [];
let deletecambio = false;

function Nuevotraslado(props) {
  const [bodegas, setBodegas] = useState([]);
  const [bodegadestino, setBodegadestino] = useState({});
  const [productoselect, setProductoselect] = useState({});
  const [productos, setProductos] = useState([]);

  const [serialeslist, setSerialeslist] = useState([]);
  const [modalseriales, setModalseriales] = useState(false);
  const [productosagregados, setProductosagregados] = useState([]);
  const [productosagregadosver, setProductosagregadosver] = useState([]);

  const [form] = Form.useForm();
  const [canSubmit, setCanSubmit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const items = [
    {
      key: "1",
      label: `Por caja`,
      children: (
        <Caja
          productosagregados={productosagregados}
          setProductosagregados={setProductosagregados}
        />
      ),
    },
    {
      key: "2",
      label: `Por serial`,
      children: (
        <Serial
          productosagregados={productosagregados}
          setProductosagregados={setProductosagregados}
        />
      ),
    },
    {
      key: "3",
      label: `Por caja y grupo`,
      children: (
        <Grupo
          productosagregados={productosagregados}
          setProductosagregados={setProductosagregados}
        />
      ),
    },
  ];
  async function fetchProductos() {
    const directus = await getDirectusClient();
    const { data: productos } = await directus.request(
      readItems("productos", {
        fields: ["*.*"],
        limit: -1,
      })
    );
    setProductos(productos);
  }

  const getVendedoresloan = async () => {
    const directus = await getDirectusClient();
    await directus
      .request(
        readItems("bodegas", {
          fields: ["id", "nombre"],
          filter: {},
        })
      )
      .then((res) => {
        console.log(res.data);
        setBodegas(res);
      })
      .catch((err) => console.log(err));
  };

  const handleSearch = async (value) => {
    console.log("buscando");
    const directus = await getDirectusClient();
    //   setLoading(true);
    const response = await directus.request(
      readUsers({
        search: value,
        fields: "*.*",
        limit: -1,
        filter: {
          role: {
            name: {
              _eq: "vendedor",
            },
          },
          tope_de_prestamo: {
            _gt: 0,
          },
        },
      })
    );
    setBodegas(response);
    // setLoadings(false);
  };

  useEffect(() => {
    getVendedoresloan();
    fetchProductos();
  }, []);
  const userBodega = useSelector((state) => state.userdata.bodega);

  const onFinish = async (ev) => {
    setIsSubmitting(true);
    const directus = await getDirectusClient();

    try {
      let seriales = [];

      // parsear datos
      console.log(ev);

      let arrguardar = [];
      let arrguardarp = [];

      let arrproducto = [];

      arraytotalproductos.map((p) => {
        arrguardar.push({
          solicitud_traslado_id: "+",
          seriales_id: { id: p.id },
        });
      });

      productosagregadosver.map((pro) => {
        arrproducto.push({ id: pro.id });
      });

      arraytotalproductos.map((p) => {
        arrguardarp.push({ id: p.id, prestamo: "+", estado: 3 });
      });

      // crear traslado
      const traslado = await directus.request(
        createItem("solicitud_traslado", {
          bodega_destino: bodegadestino.id,
          bodega: userBodega.id,
          estado: "iniciado",
          seriales: {
            create: arrguardar,
            update: [],
            delete: [],
          },
        })
      );

      // Crear entrada en historial_traslado
      // Inside onFinish function, after creating the traslado:

      // Create history entries for each serial
      await Promise.all(
        arraytotalproductos.map(async (serial) => {
          await directus.request(
            createItem("historial_traslado", {
              serial: serial.id,
              bodega_salida: userBodega.id,
              bodega_destino: bodegadestino.id,
              estado: "iniciado",
              aceptado_fecha: null,
              acaptado_por: null,
              anulado_por: null,
            
            })
          );
        })
      );

      // Update each serial status to 6
      await Promise.all(
        arraytotalproductos.map(async (serial) => {
          await directus.request(
            updateItem("seriales", serial.id, {
              estado: 6,
            })
          );
        })
      );

      Modal.success({
        title: "Proceso exitoso",
        content: "Se realizó el traslado correctamente",
      });

      // Reset states
      setProductos([]);
      setModalseriales(false);
      setProductosagregados([]);
      setProductosagregadosver([]);
      arraytotalproductos.splice(0, arraytotalproductos.length);
      setBodegadestino({});
    } catch (error) {
      console.error(error);
      Modal.error({
        title: "Error",
        content: "No se pudo crear el traslado",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const selecionado = (ev) => {
    console.log(bodegas.find((item) => item.id === ev));
    setBodegadestino(bodegas.find((item) => item.id === ev));
  };

  const selecionadoproducto = (ev) => {
    console.log(productos.find((item) => item.id === ev));
    setProductoselect(productos.find((item) => item.id === ev));
  };
  const onChange = (key) => {
    console.log(key);
  };

  useEffect(() => {
    ejecutaconversion();
  }, [productosagregados]);

  useEffect(() => {
    const isValid =
      bodegadestino.id && // Has destination selected
      arraytotalproductos.length > 0 && // Has products
      productosagregadosver.length > 0 && // Has items in table
      !(
        parseFloat(total) >
        parseFloat(
          bodegadestino.tope_de_prestamo - bodegadestino.prestamo_usado
        )
      ); // Not exceeding limit

    setCanSubmit(isValid);
  }, [bodegadestino, arraytotalproductos, productosagregadosver, total]);

  const ejecutaconversion = () => {
    let existe = 0;
    productosagregados.map((producto) => {
      producto.prestamo = "+";
      let found = arraytotalproductos.find(
        (item) => item.serial === producto.serial
      );
      if (found) {
        existe = existe + 1;
      } else {
        arraytotalproductos.push(producto);
      }
    });

    if (!deletecambio) {
      if (existe > 0) {
        Modal.error({
          title: "Seriales existentes",
          content: `Ya existen ${existe} serial(es) de los que intenta agregar al prestamo y se a(n) omitido`,
        });
      } else if (productosagregados.length > 0) {
        Modal.success({
          title: `${
            productosagregados.length - existe
          } seriales Añadidos correctamente`,
        });
      }
    }

    // Rest of the conversion logic...
    const productos = arraytotalproductos.reduce((acc, obj) => {
      // ...existing reduce code...
      const key = obj.producto?.nombre;
      if (!acc[key]) {
        acc[key] = { producto: key, seriales: [], precio: 0 };
      }
      acc[key].seriales.push({ serial: obj.serial, id: obj.id });
      acc[key].precio = obj.producto?.preciosinimp; // Asumiendo que el precio es de $100
      acc[key].impuesto = obj.producto?.grupo.impuesto; // Asumiendo que el precio es de $100
      acc[key].id = obj.producto?.id; // Asumiendo que el precio es de $100
      return acc;
    }, {});

    const productosArray = Object.values(productos);

    if (arraytotalproductos.length <= 0) {
      setProductosagregadosver([]);
    } else {
      setProductosagregadosver(productosArray);
    }
  };

  var total = 0;

  productosagregadosver.map((producto) => {
    producto.cantidad = producto.seriales.length;

    let preciot =
      parseFloat(producto.seriales.length) * parseFloat(producto.precio);
    let totalp = parseFloat(
      preciot + (preciot * producto.impuesto) / 100
    ).toFixed(2);
    producto.totalparcial = totalp;

    total = parseFloat(total) + parseFloat(totalp);
  });

  return (
    <Layouts>
      <Title level={4}>Crear Traslado</Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          name="bodega"
          label="Bodega destino"
          rules={[{ required: true }]}
        >
          <Select
            placeholder="Selecciona una Bodega"
            showSearch={true}
            filterOption={false}
            onSearch={handleSearch}
            onChange={selecionado}
            style={{ width: 200 }}
          >
            {bodegas.map((bodega) => (
              <Option key={bodega.id} value={bodega.id} allowClear>
                <span style={{ color: "#20c77c", fontSize: 12 }}>
                  {bodega.nombre}
                </span>
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Table
          columns={[
            { title: "Producto", dataIndex: "producto" },
            { title: "Cantidad", dataIndex: "cantidad" },
            { title: "Precio unitario ", dataIndex: "precio" },
            { title: "impuesto", dataIndex: "impuesto" },
            { title: "Total parcial", dataIndex: "totalparcial" },
            {
              title: "Action",
              key: "action",
              render: (_, record) => (
                <Space size="middle">
                  <Button
                    onClick={() => {
                      setSerialeslist(record.seriales);
                      setModalseriales(true);
                    }}
                    icon={<EyeOutlined />}
                    type="primary"
                  >
                    Ver seriales
                  </Button>
                  <Button
                    onClick={() => {
                      Modal.confirm({
                        title: "¿Quieres eliminar este producto?",
                        content: `Se eliminarán ${record.seriales.length} seriales asociados`,
                        onOk() {
                          // Create new array without the product to remove
                          const filteredProducts = arraytotalproductos.filter(
                            (item) => item.producto?.nombre !== record.producto
                          );

                          // Update array directly
                          arraytotalproductos.length = 0;
                          arraytotalproductos.push(...filteredProducts);

                          // Update state with empty array to force re-render
                          setProductosagregados([]);
                          setSerialeslist([]);

                          // Set delete flag
                          deletecambio = true;

                          // Force table update with new data
                          setProductosagregadosver(
                            Object.values(
                              filteredProducts.reduce((acc, obj) => {
                                const key = obj.producto?.nombre;
                                if (!acc[key]) {
                                  acc[key] = {
                                    producto: key,
                                    seriales: [],
                                    precio: obj.producto?.preciosinimp,
                                    impuesto: obj.producto?.grupo.impuesto,
                                    id: obj.producto?.id,
                                  };
                                }
                                acc[key].seriales.push({
                                  serial: obj.serial,
                                  id: obj.id,
                                });
                                return acc;
                              }, {})
                            )
                          );
                        },
                      });
                    }}
                    icon={<DeleteOutlined />}
                    type="primary"
                  >
                    Quitar producto
                  </Button>
                </Space>
              ),
            },
          ]}
          dataSource={productosagregadosver}
        ></Table>
        Total a traslado : {total}{" "}
        <span style={{ color: "red" }}>
          {parseFloat(total) >
          parseFloat(
            bodegadestino.tope_de_prestamo - bodegadestino.prestamo_usado
          )
            ? "Se excedió el limite de prestamo para el vendedor seleccionado"
            : console.log(
                parseFloat(
                  bodegadestino.tope_de_prestamo - bodegadestino.prestamo_usado
                )
              )}
        </span>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button
            disabled={!canSubmit || isSubmitting}
            loading={isSubmitting}
            type="primary"
            htmlType="submit"
          >
            {isSubmitting ? "Haciendo traslado..." : "Crear traslado"}
          </Button>
        </Form.Item>
      </Form>

      <h4>Añadir productos al traslado</h4>
      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
      <Modal
        title="Seriales"
        onOk={() => {
          setSerialeslist([]);
          setModalseriales(false);
          deletecambio = false;
        }}
        onCancel={() => {
          setModalseriales(false);
          deletecambio = false;
        }}
        open={modalseriales}
      >
        {serialeslist.map((serial) => {
          return (
            <Space size={"small"}>
              {" "}
              <span>{serial.serial}</span>
              <Button
                onClick={() => {
                  console.log("eliminar serial " + serial.serial);
                  console.log(productosagregados);

                  Modal.confirm({
                    title: "Quieres eliminar serial " + serial.serial,
                    onOk() {
                      let nuevosseriales = productosagregados.filter(
                        (item) => item.serial !== serial.serial
                      );

                      let arran = arraytotalproductos.filter(
                        (item) => item.serial !== serial.serial
                      );

                      arraytotalproductos.splice(0, arraytotalproductos.length);

                      arran.map((a) => {
                        arraytotalproductos.push(a);
                      });

                      let lisserrialnew = serialeslist.filter(
                        (item) => item.serial !== serial.serial
                      );

                      setSerialeslist(lisserrialnew);

                      console.log(productosagregados.length);

                      setProductosagregados(nuevosseriales);
                      deletecambio = true;
                    },
                    onCancel() {
                      console.log("cancelar");
                    },
                  });
                }}
              >
                Eliminar
              </Button>
            </Space>
          );
        })}
      </Modal>
    </Layouts>
  );
}

export default Nuevotraslado;
